/**
 * Shared "already fetched my integrations" key for useTenantPosConnections.
 * Lives outside the hook so auth logout/login can reset without importing React.
 */
let lastAttemptedKey = null

export const resolveTenantPosAttemptKey = (userId, authUser) => {
  const fromState =
    userId != null && String(userId).trim() !== "" ? String(userId) : ""
  if (fromState) return fromState
  const fromAuth =
    authUser?._id ||
    authUser?.id ||
    authUser?.userId ||
    authUser?.user?._id ||
    authUser?.user?.id ||
    ""
  if (fromAuth) return String(fromAuth)
  return "anonymous"
}

export const getTenantPosConnectionsAttemptKey = () => lastAttemptedKey

export const setTenantPosConnectionsAttemptKey = key => {
  lastAttemptedKey = key == null ? null : String(key)
}

export const resetTenantPosConnectionsAttempt = () => {
  lastAttemptedKey = null
}
